import { render, staticRenderFns } from "./FactoringContractThirdPartyModal.vue?vue&type=template&id=871150d8&scoped=true&lang=pug&"
import script from "./FactoringContractThirdPartyModal.vue?vue&type=script&lang=js&"
export * from "./FactoringContractThirdPartyModal.vue?vue&type=script&lang=js&"
import style0 from "./FactoringContractThirdPartyModal.vue?vue&type=style&index=0&id=871150d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871150d8",
  null
  
)

/* custom blocks */
import block0 from "./FactoringContractThirdPartyModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports